import "./styles.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { nutzungZustand } from "./api/nutzung";
import { registriertAufraeumen } from "./api/registriert";
import { abfragenAnlegen } from "./api/sitzung";
import type { Ich } from "./api/typen";
import { App } from "./App";
import { bandFuerNutzer } from "./design/bandZustand";
import { darstellungAnwenden } from "./darstellung";
import { weltAnwenden } from "./welt/einstellungen";

darstellungAnwenden();
weltAnwenden();
// W82 Web-10b W10B-5 (WN-33): ein abgelaufener Merker „Konto angelegt“ fällt auf jeder Seite, nicht nur beim Anmelden
registriertAufraeumen();

const abfragen = abfragenAnlegen();

// W15 Nutzungsstatistik: folgt an einer Stelle dem Stand von „ich“, gleich woher er kommt
// (Anmelden, Registrieren, Abmelden, abgelaufene Sitzung, Widerspruch in den Einstellungen)
abfragen.getQueryCache().subscribe((ereignis) => {
  if (ereignis.query.queryKey[0] !== "ich") return;
  const ich = ereignis.type === "removed" ? null : (ereignis.query.state.data as Ich | null | undefined);
  nutzungZustand(Boolean(ich) && !ich?.nutzer.nutzung_aus, ich?.csrf ?? "");
  // W51 (F33): abgemeldet oder ein anderer Nutzer: das Band spaeter Speicherfehler ist leer
  bandFuerNutzer(ich?.nutzer.id ?? null);
});

const wurzel = document.getElementById("wurzel");
if (!wurzel) throw new Error("Element #wurzel fehlt in index.html");

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
